import { PackagePhoto } from '@/model/Logistic/Shipment/Shipment';

/**
 * Metadata: Utilidades para la gestión de archivos tributarios en envíos.
 * Los archivos tributarios se identifican por una descripción con formato "tax_file_{shipmentId}".
 * Este código se usa como clave para subir y consultar el archivo.
 */

/** Genera el código de descripción que identifica un archivo tributario para un envío */
export const getTaxFileCode = (shipmentId: number): string => `tax_file_${shipmentId}`;

/** Determina si un envío tiene al menos un archivo tributario cargado */
export const hasTaxFile = (photos: PackagePhoto[] | undefined, shipmentId: number): boolean => {
  if (!photos || photos.length === 0) return false;
  const code = getTaxFileCode(shipmentId);

  return photos.some(p => p.description === code);
};

/** Filtra las fotos que corresponden al archivo tributario del envío */
export const getTaxFilePhotos = (
  photos: PackagePhoto[] | undefined,
  shipmentId: number,
): PackagePhoto[] => {
  if (!photos || photos.length === 0) return [];
  const code = getTaxFileCode(shipmentId);

  return photos.filter(p => p.description === code);
};

/**
 * Metadata: Utilidades para la gestión de etiquetas de envío.
 * Las etiquetas se identifican por una descripción con formato "shipping_label_file_{shipmentId}".
 */

/** Genera el código de descripción que identifica una etiqueta de envío */
export const getShippingLabelFileCode = (shipmentId: number): string =>
  `shipping_label_file_${shipmentId}`;

/** Filtra las fotos que corresponden a la etiqueta de envío */
export const getShippingLabelFilePhotos = (
  photos: PackagePhoto[] | undefined,
  shipmentId: number,
): PackagePhoto[] => {
  if (!photos || photos.length === 0) return [];
  const code = getShippingLabelFileCode(shipmentId);

  return photos.filter(p => p.description === code);
};
